<template>
  <div class="menu-container">
    <div :class="['hamburger', active ? 'is-active' : '']" id="hamburger-1" @click="clickMenu"><span class="line"></span><span class="line"></span><span class="line"></span></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: false
    }
  },
  props: {

  },
  components: {

  },
  mounted() {

  },
  methods: {
    clickMenu() {
      this.active = !this.active;
      this.$emit("clickMenu", this.active);
      if (this.active) {
        this.stopScroll();
      } else {
        this.canScroll();
      }
    }
  },
  watch: {
    "$route": {
      handler() {
        this.active = false;
        this.canScroll();
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
/* 列 */
.menu-container {
  display: block;
  float: left;
  margin: 1% 0 1% 1.6%;
}

.menu-container:first-of-type {
  margin-left: 50;
}

.hamburger .line {
  width: 20px;
  height: 2px;
  background-color: #ecf0f1;
  display: block;
  margin: 5px auto;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.hamburger:hover {
  cursor: pointer;
}

/* 示例1 */
#hamburger-1.is-active .line:nth-child(2) {
  opacity: 0;
}

#hamburger-1.is-active .line:nth-child(1) {
  -webkit-transform: translateY(7px) rotate(45deg);
  -ms-transform: translateY(7px) rotate(45deg);
  -o-transform: translateY(7px) rotate(45deg);
  transform: translateY(7px) rotate(45deg);
}

#hamburger-1.is-active .line:nth-child(3) {
  -webkit-transform: translateY(-7px) rotate(-45deg);
  -ms-transform: translateY(-7px) rotate(-45deg);
  -o-transform: translateY(-7px) rotate(-45deg);
  transform: translateY(-7px) rotate(-45deg);
}
</style>